/* istanbul ignore file */
import { Directive, ElementRef } from '@angular/core';

@Directive({
	selector: 'vp-sheet-content, [vp-sheet-content], [vpSheetContent]',
	standalone: false,
})
export class SheetContentDirective {
	constructor(readonly elementRef: ElementRef) {
		elementRef.nativeElement.classList.add(
			'overflow-y-auto',
			'block',
			'will-change-scroll',
			'p-4',
			'sm:p-6',
		);
	}
}

@Directive({
	selector: 'vp-sheet-header, [vp-sheet-header], [vpSheetHeader]',
	standalone: false,
})
export class SheetHeaderDirective {
	constructor(readonly elementRef: ElementRef) {
		elementRef.nativeElement.classList.add(
			'flex-1',
			'children:mb-0',
			'children:text-lg',
			'children:font-semibold',
			'children:text-dark-primary',
		);
	}
}
